import React, { useState, useEffect } from 'react';
import { Card, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeader1 from '../../components/common/PageHeader1';
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import apiClient from "../../utils/api";

function TicketSettingsList() {
    const [settings, setSettings] = useState([]);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/ticket-settings', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSettings(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading ticket settings');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this setting?')) {
            return;
        }
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/ticket-settings/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Setting deleted successfully');
            fetchSettings();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error deleting setting');
        }
    };

    const handlePrint = (id) => {
        const setting = settings.find(s => s.id === id);
        if (!setting) return;

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Sample Ticket - ${setting.ticket_format}</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        .ticket { 
                            border: 1px solid #ccc; 
                            padding: 15px; 
                            max-width: 300px; 
                            margin: auto;
                        }
                        .header { text-align: center; margin-bottom: 15px; }
                        .info-row { margin: 8px 0; }
                        .label { font-weight: bold; }
                        .qr-code { text-align: center; margin: 15px 0; }
                        .footer { text-align: center; font-size: 0.9em; margin-top: 15px; }
                    </style>
                </head>
                <body>
                    <div class="ticket">
                        <div class="header">
                            <h2>Sample Ticket</h2>
                            <p>${setting.ticket_format}</p>
                        </div>
                        ${setting.car_details ? `
                            <div class="info-row">
                                <span class="label">Car Details:</span> Sample Car Details
                            </div>
                        ` : ''}
                        ${setting.incident_notes ? `
                            <div class="info-row">
                                <span class="label">Notes:</span><br/>
                                ${setting.incident_notes}
                            </div>
                        ` : ''}
                        <div class="footer">
                            Sample ticket format - For preview only
                        </div>
                    </div>
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 
                    pagetitle='Ticket Settings' 
                    righttitle='Add Setting'
                    link='/accounts/ticket-settings/add'
                    routebutton={true}
                />
				
                <Card>
                    <Card.Body>
                        <Table responsive striped hover>
                            <thead>                                <tr>
                                    <th>#</th>
                                    <th>Ticket Format</th>
                                    <th>Manual Printing</th>
                                    <th>Car Details</th>
                                    <th>Incident Notes</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {settings.map((setting) => (
                                    <tr key={setting.id}>                                        <td>{setting.id}</td>
                                        <td>{setting.ticket_format}</td>
                                        <td>{setting.manual_printing ? 'Enabled' : 'Disabled'}</td>
                                        <td>{setting.car_details ? 'Yes' : 'No'}</td>
                                        <td>{setting.incident_notes}</td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <EditButton
                                                    permission="ticket-settings.edit"
                                                    to={`${process.env.PUBLIC_URL}/accounts/ticket-settings/edit/${setting.id}`}
                                                    className="btn btn-outline-secondary"
                                                    title="Edit Setting"
                                                >
                                                    <i className="fa fa-edit"></i>
                                                </EditButton>
                                                <DeleteButton
                                                    permission="ticket-settings.delete"
                                                    onDelete={() => handleDelete(setting.id)}
                                                    className="btn btn-outline-danger"
                                                    title="Delete Setting"
                                                >
                                                    <i className="fa fa-trash"></i>
                                                </DeleteButton>
                                                <button 
                                                    type="button"
                                                    className="btn btn-outline-info"
                                                    onClick={() => window.open(`/accounts/ticket-preview/${setting.id}`, '_blank')}
                                                    title="Preview Ticket"
                                                >
                                                    <i className="fa fa-eye"></i>
                                                </button>
                                                <button 
                                                    type="button"
                                                    className="btn btn-outline-success"
                                                    onClick={() => handlePrint(setting.id)}
                                                    title="Print Sample"
                                                >
                                                    <i className="fa fa-print"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default TicketSettingsList;